import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  paper: {
    marginTop: 24,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    maxHeight: 'calc(75vh - 150px)',
  },
  gridItem: {
    padding: '5px 10px',
    textAlign: 'center',
    display: 'flex',
    height: 65,
  },
};

export default styles;
